const withLeadingZero = (value: number) => String(value).padStart(2, "0");

export const formatReleaseDate = (
  releaseDate: string | null,
): string | null => {
  const date = releaseDate ? new Date(releaseDate) : null;

  if (!date || Number.isNaN(date.getTime())) return null;

  return [
    withLeadingZero(date.getUTCDate()),
    withLeadingZero(date.getUTCMonth() + 1),
    date.getUTCFullYear(),
  ].join(".");
};
